import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { ModalUpsellWrapperProps } from '../src/CompanyHub/ModalUpsellWrapper.tsx';
import type { ExtensionSource } from './PremiumExtensionsUpsell.tsx';

export const ExtensionConfigUpsellLoader: LoadableType<{
	feature:
		| 'premiumCardsConfig'
		| 'premiumCarouselConfig'
		| 'premiumSpotlightConfig'
		| 'premiumSearchConfig';
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ExtensionConfigUpsell" */ '../src/CompanyHub/ExtensionConfigUpsell.tsx'
			)
		).ExtensionConfigUpsell,
});

export const ExtensionInsertUpsellLoader: LoadableType<
	Pick<ModalUpsellWrapperProps, 'setUpsellModalSource'> & {
		feature: ExtensionSource;
	}
> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ExtensionInsertUpsell" */ '../src/CompanyHub/ExtensionInsertUpsell.tsx'
			)
		).ExtensionInsertUpsell,
});

export type { ExtensionSource } from '../src/CompanyHub/companyHubUpsellTypes.ts';
